import { useEffect, useState, useCallback } from 'react';

interface ToastMessage {
  id: string;
  text: string;
  type: 'success' | 'error' | 'info';
}
let toastListeners: ((toast: ToastMessage) => void)[] = [];

export function showToast(text: string, type: 'success' | 'error' | 'info' = 'info') {
  toastListeners.forEach(fn => fn({ id: crypto.randomUUID(), text, type }));
}

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);
  const addToast = useCallback((toast: ToastMessage) => {
    setToasts(prev => [...prev, toast]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== toast.id)), 4000);
  }, []);

  useEffect(() => {
    toastListeners.push(addToast);
    return () => {
      toastListeners = toastListeners.filter(fn => fn !== addToast);
    };
  }, [addToast]);

  if (toasts.length === 0) return null;

  const styles = {
    success: 'bg-ink text-white',
    error: 'bg-rose text-white',
    info: 'bg-surface text-ink border border-surface-border',
  };

  return (
    <div className="fixed top-20 right-5 z-[100] space-y-2 pointer-events-none">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`${styles[toast.type]} pointer-events-auto px-5 py-3 rounded-xl shadow-lift font-sans text-sm flex items-center gap-3 animate-slide-in-right min-w-[260px] max-w-[380px]`}
        >
          <span className="leading-snug flex-1" style={{ fontWeight: 400 }}>
            {toast.text}
          </span>
          <button
            onClick={() => setToasts(prev => prev.filter(t => t.id !== toast.id))}
            className="opacity-40 hover:opacity-100 transition-opacity"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
